import { render, staticRenderFns } from "./session-charges-table.vue?vue&type=template&id=4c12766b&"
import script from "./session-charges-table.vue?vue&type=script&lang=js&"
export * from "./session-charges-table.vue?vue&type=script&lang=js&"
import style0 from "./session-charges-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports